import { FC, useEffect } from "react";
import { useAuth } from "./context/auth-context";
import { useUser } from "./context/user-context";
import { useAuth0 } from "@auth0/auth0-react";

const Logout: FC = () => {
  const auth = useAuth();
  const { logout } = useAuth0();
  const userContext = useUser();

  useEffect(() => {
    auth?.logout();
    logout({
      logoutParams: {
        returnTo: import.meta.env.REACT_APP_AUTH0_LOGOUT_REDIRECT_URI || "",
      },
    });
  }, [auth, logout, userContext]);

  return null;
};

export default Logout;
